import React from "react";
import Header from "../../appLayout/header";
import "./index.scss";
import img from "../../../assets/images/slide.png";
import { useNavigate } from "react-router-dom";
import { FlechBtn } from "../../../assets/icons/FlechBtn";
export const SlideHome = () => {
  const navigate = useNavigate();

  return (
    <div className="slide-home">
      <div className="header-home pt-md-5 p-md-5 p-0">
        <Header />
      </div>
      <div className="slide-homer-container  ">
        <div className="row w-100 h-100 ms-0">
          <div className="col-lg-1"></div>
          <div className="col-lg-7 h-auto col-12">
            {" "}
            <div className="slide-home-container-content ">
              <div className="slide-home-container-content-subtitle ">
                <img className="img-slide" src={img} alt="image" />
                +600 clients satisfaits
              </div>
              <h1 className="slide-home-container-content-title mt-3">
                Experts en rénovation énergétique et ravalement en Île-de-France
              </h1>
              <p className="slide-home-container-content-description">
                Isolation, ravalement et rénovation globale : votre partenaire
                certifié RGE
              </p>
              <div>
                {" "}
                <a class="btn-slide" href="/contact">
                  <span class="circle">
                    <FlechBtn />
                  </span>

                  <span class="title">Demander un devis gratuit</span>
                  <span class="title title-hover">
                    Demander un devis gratuit
                  </span>
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
